import { SelectInput } from '@/src/common/components/elements/Forms/SelectWithLabel'
import { TextInputWithLabel } from '@/src/common/components/elements/Forms/TextInputWithLabel'
import { clearFormErrorForField } from '@/src/common/utilities/clearFormErrorForField'
import { inputHasError } from '@/src/common/utilities/inputHasError'
import { states } from '@/src/common/utilities/stateAbbreviations'
import { FormErrorDisplay } from '@/src/modules/build-a-card/FormErrorDisplay'
import { addressMax } from '@/src/modules/build-a-card/constants'
import { IDeliveryStreetAddress } from '@/src/modules/cart/ICart'
import { HalfFieldsWrapper } from '@/src/modules/checkout/StyledComponents'
import { StyledFieldWrapper } from '@/src/modules/pg-plus/PGPlusStyledComponents'
import { FieldWrapper } from '@/src/modules/smarty/StyledComponents'
import { trimStart } from 'lodash'
import { BaseSyntheticEvent } from 'react'
import { ValidationError } from 'yup'

interface IManualFormProps {
    address: IDeliveryStreetAddress
    setAddress: Function
    formErrors: ValidationError[]
    setFormErrors: Function
}

export default function ManualAddressForm({
    address,
    setAddress,
    formErrors,
    setFormErrors,
}: IManualFormProps) {
    return (
        <>
            <FieldWrapper>
                <TextInputWithLabel
                    id={'address1'}
                    value={address?.address1 ?? ''}
                    label={'Address 1'}
                    placeholder={'Address 1'}
                    onChange={(e: BaseSyntheticEvent) => {
                        let trimmedValue = trimStart(e.currentTarget.value)
                        setAddress({
                            ...address,
                            address1: trimmedValue,
                        })
                        clearFormErrorForField({
                            path: 'address1',
                            formErrors: formErrors,
                            setFormErrors: setFormErrors,
                        })
                    }}
                    hasError={inputHasError(formErrors, 'address1')}
                    autoComplete={'address-line1'}
                    maxLength={addressMax}
                />
                <FormErrorDisplay formErrors={formErrors} path={'address1'} />
            </FieldWrapper>

            <FieldWrapper>
                <TextInputWithLabel
                    id={'address2'}
                    value={address?.address2 ?? ''}
                    label={'Address 2'}
                    placeholder={'Address 2'}
                    onChange={(e: BaseSyntheticEvent) => {
                        let trimmedValue = trimStart(e.currentTarget.value)
                        setAddress({
                            ...address,
                            address2: trimmedValue,
                        })
                        clearFormErrorForField({
                            path: 'address2',
                            formErrors: formErrors,
                            setFormErrors: setFormErrors,
                        })
                    }}
                    hasError={inputHasError(formErrors, 'address2')}
                    autoComplete={'address-line2'}
                    maxLength={addressMax}
                />
                <FormErrorDisplay formErrors={formErrors} path={'address2'} />
            </FieldWrapper>
            <FieldWrapper>
                <TextInputWithLabel
                    id={'city'}
                    value={address?.city ?? ''}
                    label={'City'}
                    placeholder={'City'}
                    onChange={(e: BaseSyntheticEvent) => {
                        let trimmedValue = trimStart(e.currentTarget.value)
                        setAddress({
                            ...address,
                            city: trimmedValue,
                        })
                        clearFormErrorForField({
                            path: 'city',
                            formErrors: formErrors,
                            setFormErrors: setFormErrors,
                        })
                    }}
                    hasError={inputHasError(formErrors, 'city')}
                    autoComplete={'address-level2'}
                    maxLength={addressMax}
                />
                <FormErrorDisplay formErrors={formErrors} path={'city'} />
            </FieldWrapper>
            <HalfFieldsWrapper>
                <StyledFieldWrapper maxWidth={'half-width'}>
                    <SelectInput
                        fieldWrapperVariant={'shipping-form'}
                        className={'select-input'}
                        value={address?.state}
                        label={'State'}
                        placeholder={'State'}
                        options={states}
                        hasError={inputHasError(formErrors, 'state')}
                        onValueChange={(value: string) => {
                            setAddress({
                                ...address,
                                state: value,
                            })
                            clearFormErrorForField({
                                path: 'state',
                                formErrors: formErrors,
                                setFormErrors: setFormErrors,
                            })
                        }}
                    />
                    <FormErrorDisplay formErrors={formErrors} path={'state'} />
                </StyledFieldWrapper>
                <StyledFieldWrapper maxWidth={'half-width'}>
                    <TextInputWithLabel
                        id={'zip'}
                        value={address?.zip}
                        placeholder={'Zip Code'}
                        autoComplete={'postal-code'}
                        label={address?.zip ? 'Zip Code' : ''}
                        onChange={(e: BaseSyntheticEvent) => {
                            let trimmedValue = trimStart(e.currentTarget.value)
                            setAddress({
                                ...address,
                                zip: trimmedValue,
                            })
                            clearFormErrorForField({
                                path: 'zip',
                                formErrors: formErrors,
                                setFormErrors: setFormErrors,
                            })
                        }}
                        numFormat={'#####'}
                        hasError={inputHasError(formErrors, 'zip')}
                    />
                    <FormErrorDisplay formErrors={formErrors} path={'zip'} />
                </StyledFieldWrapper>
            </HalfFieldsWrapper>
        </>
    )
}
